import cn from 'classnames';
import React, {FunctionComponent} from 'react';

type TitleNumberProps = {
  value: number
  change?: number
  className?: string
}

/**
 * Title card number. It's usually based in the top right corner
 * @param value {number} Value
 * @param change {number} Positive or negative change in the value
 * @constructor
 */
const TitleNumber: FunctionComponent<TitleNumberProps> = ({value, change, className}) =>
  (
    <div className={cn(className, 'flex items-start')}>
      <span className={cn('text-5xl font-bold', {'text-gray-dark': value === 0})}>{value}</span>
      {change &&
        <>
        <span className={cn('text-sm text-white font-bold rounded-full py-0.5 px-1.5 leading-3 mt-3 ml-1', {
          'bg-green': change > 0,
          'bg-red': change < 0
        })}>{change > 0 ? `+${change}` : change}</span>
        </>
      }
    </div>
  );

export default TitleNumber;
